import {TOGGLE_COMPLIANCE_STATUS_VIEW, TOGGLE_COMPLIANCE_DATE_VIEW, SET_COMPLIANCE_PERCENTAGE, SET_COMPLIANCE_DEFAULT_LOAD } from '../actions/actionTypes'
import commonConfig from '../../components/commonConfig.json'

const initState = {
    status : "All",
    transpose : "horizontal",
    compliancePercentage : [0.00, 1.00],
    defaultLoad: 4,
    // customTabView : commonConfig.customTabView.DEFAULT //change to app permissions
}

const complianceTableReducer = (state = initState, action) => {
    // console.log("Reducer", JSON.stringify(action))
    switch(action.type){
        case TOGGLE_COMPLIANCE_STATUS_VIEW : return {
            ...state,
            status : action.status
        }
        case TOGGLE_COMPLIANCE_DATE_VIEW : return {
            ...state,
            transpose : action.transpose
        }
        case SET_COMPLIANCE_PERCENTAGE : return {
            ...state,
            compliancePercentage : action.compliancePercentage
        }
        case SET_COMPLIANCE_DEFAULT_LOAD: return {
            ...state,
            defaultLoad: action.defaultLoad
        }
        // case SET_COMPLIANCE_CUSTOM_TAB_VIEW : return {
        //     ...state,
        //     customTabView : action.customTabView
        // }
        default : return state
    }
};

export default complianceTableReducer;